/* 管理分组下 路由集合 */

import Layout from '@/layout'
import { getTabRedirectPath } from '@/utils/router'

/* 业务数据 路由集合 */
export const statisticsRouters = {
  path: '/statistics',
  component: Layout,
  meta: {
    title: '业务数据',
    icon: 'bar-chart-line',
    alwaysShow: true,
  },
  redirect: '/statistics/shop_statistics',
  children: [
    {
      path: 'shop_statistics',
      name: 'statistic_shop_statistics',
      hidden: true,
      component: () => import('@/views/management/statistics/shopStatistics/index'),
      meta: {
        title: '销售统计数据',
        icon: '',
        tabUrl: true,
        tabArr: {
          day: '每日统计',
          week: '每周统计',
          month: '每月统计',
          integral_seckill: '积分/秒杀商城统计',
        },
      },
    },
    {
      path: 'group_manage',
      name: 'statistic_group_manage',
      hidden: true,
      component: () => import('@/views/management/statistics/statisticGroupManage/index'),
      meta: {
        title: '统计分组管理',
        icon: '',
      },
    },
    {
      path: 'shop_statistics_tab_day',
      redirect: (to) => getTabRedirectPath(to),
      name: 'statistic_shop_statistics_tab_day',
      meta: {
        title: '每日统计',
        icon: '',
      },
    },
    {
      path: 'shop_statistics_tab_week',
      redirect: (to) => getTabRedirectPath(to),
      name: 'statistic_shop_statistics_tab_week',
      meta: {
        title: '每周统计',
        icon: '',
      },
    },
    {
      path: 'shop_statistics_tab_month',
      redirect: (to) => getTabRedirectPath(to),
      name: 'statistic_shop_statistics_tab_month',
      meta: {
        title: '每月统计',
        icon: '',
      },
    },
    {
      path: 'ticket_statistics',
      name: 'statistic_ticket_statistics',
      component: () => import('@/views/management/statistics/ticketStatistics/index'),
      meta: {
        title: '红包管理及统计',
        icon: '',
        tabName: {
          manage: '红包管理',
          all_ticket: '红包统计',
        },
      },
    },
    {
      path: 'search_topic',
      name: 'statistic_search_topic',
      component: () => import('@/views/management/statistics/searchTopic/index'),
      meta: {
        title: '搜索记录',
        icon: '',
      },
    },
    {
      path: 'shop_modal',
      name: 'statistic_shop_modal',
      hidden: true,
      component: () => import('@/views/management/statistics/shopStatisticsModal'),
      meta: {
        title: '商品统计弹窗',
        icon: '',
        modalPage: true,
      },
    },
  ],
}

/* 统计分析系统 路由集合 */
export const trackRouters = {
  path: '/track',
  component: Layout,
  meta: {
    title: '统计分析系统',
    icon: 'line-chart-line',
    alwaysShow: true,
  },
  redirect: '/track/event_list',
  children: [
    {
      path: 'event_list',
      name: 'track_event_list',
      component: () => import('@/views/management/track/eventList/index'),
      meta: {
        title: '事件管理',
        icon: '',
      },
    },
    {
      path: 'operation_overview',
      name: 'track_operation_overview',
      component: () => import('@/views/management/track/operationOverview/index'),
      meta: {
        title: '用户运营总览',
        icon: '',
      },
    },
  ],
}

export const customerManageRouters = {
  path: '/customer_manage',
  component: Layout,
  meta: {
    title: '客户管理',
    icon: 'contacts-line',
    alwaysShow: true,
  },
  redirect: '/customer_manage/transfer_test_log',
  children: [
    {
      path: 'wx_user',
      name: 'customer_manage_wx_user',
      component: () => import('@/views/management/customerManage/wxUser/index'),
      meta: {
        title: '微信用户',
        icon: '',
      },
    },
    {
      path: 'transfer_test_log',
      name: 'customer_manage_transfer_test_log',
      component: () => import('@/views/management/customerManage/transferTestLog/index'),
      meta: {
        title: '转考试日志',
        icon: '',
      },
    },
    {
      path: 'kefu_feedback',
      name: 'customer_manage_kefu_feedback',
      component: () => import('@/views/management/customerManage/kefuFeedback/index'),
      meta: {
        title: '反馈处理',
        icon: '',
      },
    },
    {
      path: 'monitor',
      name: 'monitor_index',
      component: () => import('@/views/management/customerManage/monitor/index'),
      meta: {
        title: '可疑用户',
        icon: '',
      },
    },
  ],
}

export const marketingManagementRouters = {
  path: '/marketingManagement',
  component: Layout,
  meta: {
    title: '营销管理',
    icon: 'account-pin-box-fill',
    alwaysShow: true,
  },
  redirect: '/marketingManagement/circle_of_friends',
  children: [
    {
      path: 'share_card_setting',
      name: 'system_setting_share_card_setting',
      component: () => import('@/views/system/systemSetting/shareCardSetting/index'),
      meta: {
        title: '分享配置',
        icon: '',
      },
    },
    {
      path: 'circle_of_friends',
      name: 'circle_of_friends_index',
      component: () => import('@/views/management/marketingManagement/circleOfFriends/index'),
      meta: {
        title: '朋友圈转发',
        icon: '',
      },
    },
    {
      path: 'enterprise_wx_qr',
      name: 'enterprise_wx_qr_index',
      component: () => import('@/views/management/marketingManagement/enterpriseWxQr/index'),
      meta: {
        title: '企业群活码',
        icon: '',
      },
    },
    {
      path: 'push_manage',
      name: 'push_manage_index',
      component: () => import('@/views/management/marketingManagement/pushManage/index'),
      meta: {
        title: '消息管理',
        icon: '',
      },
    },
    {
      path: 'daily_chicken_soup',
      name: 'daily_chicken_soup_index',
      component: () => import('@/views/management/marketingManagement/dailyChickenSoup/index'),
      meta: {
        title: '加载文案管理',
        icon: '',
      },
    },
    {
      path: 'float_msg',
      name: 'float_msg_index',
      component: () => import('@/views/management/marketingManagement/floatMsg/index'),
      meta: {
        title: '浮层消息推送',
        icon: '',
      },
    },
    {
      path: 'quick_score',
      name: 'quick_score',
      component: () => import('@/views/management/marketingManagement/quickScore/index'),
      meta: {
        title: '卫考出分推送确认',
        icon: '',
      },
    },
  ],
}

export const agentRouters = {
  path: '/channelAgent',
  component: Layout,
  meta: {
    title: '渠道代理',
    icon: 'profile-line',
    alwaysShow: true,
  },
  redirect: '/channelAgent/test_user_agent',
  children: [
    {
      path: 'test_user_agent',
      name: 'channelAgent_test_user_agent',
      component: () => import('@/views/management/channelAgent/testUserAgent/index'),
      meta: {
        title: '考试用户代理',
        icon: '',
      },
    },
  ],
}

export const partTimeJobRouters = {
  path: '/part_time_job',
  component: Layout,
  meta: {
    title: '兼职',
    icon: 'map-pin-time-line',
    alwaysShow: true,
  },
  redirect: '/part_time_job/index',
  children: [
    {
      path: 'index',
      name: 'part_time_job_index',
      hidden: true,
      component: () => import('@/views/management/partTimeJob/index'),
      meta: {
        title: '兼职管理',
        icon: '',
        tabUrl: true,
        tabArr: {
          taskCheck: '任务审核',
          dataManager: '数据管理',
          userManager: '用户管理',
          newbieTask: '新手任务',
        },
      },
    },
    {
      path: 'index_tab_taskCheck',
      redirect: (to) => getTabRedirectPath(to),
      name: 'part_time_job_index_tab_taskCheck',
      meta: {
        title: '任务审核',
        icon: '',
      },
    },
    {
      path: 'index_tab_dataManager',
      redirect: (to) => getTabRedirectPath(to),
      name: 'part_time_job_index_tab_dataManager',
      meta: {
        title: '数据管理',
        icon: '',
      },
    },
    {
      path: 'index_tab_userManager',
      redirect: (to) => getTabRedirectPath(to),
      name: 'part_time_job_index_tab_userManager',
      meta: {
        title: '用户管理',
        icon: '',
      },
    },
    {
      path: 'index_tab_newbieTask',
      redirect: (to) => getTabRedirectPath(to),
      name: 'part_time_job_index_tab_newbieTask',
      meta: {
        title: '新手任务',
        icon: '',
      },
    },
    {
      path: 'abandon',
      name: 'part_time_job_abandon',
      component: () => import('@/views/management/partTimeJob/components/PartTimeAbandon/index'),
      meta: {
        title: '兼职放弃题目',
        icon: '',
      },
    },
  ],
}

export const advertisementRouters = {
  path: '/advertisement',
  component: Layout,
  meta: {
    title: '广告',
    icon: 'radio-line',
    alwaysShow: true,
  },
  redirect: '/advertisement/common_ad',
  children: [
    {
      path: 'common_ad',
      name: 'common_ad_index',
      component: () => import('@/views/management/advertisement/commonAd/index'),
      meta: {
        title: '通用广告',
        icon: '',
        tabName: {
          ad_setup: '广告设置',
          ad_statistics: '广告统计',
          img_manage: '配图管理',
          txt_statistics: '文案管理',
          api_explain: '接口调用说明',
        },
      },
    },
    {
      path: 'media_config',
      name: 'common_ad_media_config',
      component: () => import('@/views/management/advertisement/commonAd/mediaConfig'),
      meta: {
        title: '自动化群发',
        icon: '',
        tabName: {
          media_template_manage: '自动化群发',
          auto_media_config: '自动化群发配置',
        },
      },
    },
    {
      path: 'index_ad',
      name: 'index_ad_index',
      component: () => import('@/views/management/advertisement/indexAd/index'),
      meta: {
        title: '首页广告',
        icon: '',
        tabName: {
          IndexAd: '首页广告',
        },
      },
    },
  ],
}

export const IssueKaoxunRouters = {
  path: '/issue_kaoxun',
  component: Layout,
  meta: {
    title: '问答资讯',
    icon: '',
  },
  redirect: '/issue_kaoxun/index',
  children: [
    {
      path: 'index',
      name: 'issue_kaoxun_index',
      component: () => import('@/views/management/issueKaoxun/index'),
      meta: {
        title: '问答资讯',
        icon: 'questionnaire-line',
        tabName: {
          issue: '问答',
          information: '资讯',
        },
      },
    },
    {
      path: 'storylist',
      name: 'issue_kaoxun_storylist',
      component: () => import('@/views/management/issueKaoxun/storylist/index'),
      meta: {
        title: '故事列表',
        icon: '',
      },
    },
  ],
}

export const ActivityRouters = {
  path: '/activity',
  component: Layout,
  meta: {
    title: '活动管理',
    icon: 'gift-2-line',
    alwaysShow: true,
  },
  redirect: '/activity/index',
  children: [
    {
      path: 'vip_old_new',
      name: 'vip_old_new_index',
      component: () => import('@/views/management/activity/vipOldNew/index'),
      meta: {
        title: 'VIP题库以旧换新',
        icon: '',
      },
    },
    {
      path: 'promotion_activity',
      name: 'promotion_activity',
      component: () => import('@/views/management/activity/promotionActivity/index'),
      meta: {
        title: '促销活动',
        icon: '',
      },
    },
    {
      path: 'thousands_act',
      name: 'thousands_act_index',
      component: () => import('@/views/management/activity/thousandsAct/index'),
      meta: {
        title: '活动列表',
        icon: '',
        tabName: {
          act_list: '活动列表',
          act_compare: '活动对比',
        },
      },
    },
    {
      path: 'thousands_act_old',
      name: 'thousands_act_index_old',
      component: () => import('@/views/management/activity/thousandsAct/indexOld'),
      meta: {
        title: '活动列表（旧版）',
        icon: '',
        tabName: {
          act_list: '活动列表（旧版）',
          act_compare: '活动对比',
        },
      },
    },
  ],
}

export const PartnerBackgroundRouters = {
  path: '/partner_background',
  component: Layout,
  meta: {
    title: '合作商后台',
    icon: 'account-box-fill',
    alwaysShow: true,
  },
  redirect: '/partner_background/index',
  children: [
    {
      path: 'index',
      name: 'background_video_course',
      component: () => import('@/views/management/partnerBackground/videoCourseManagement/index'),
      meta: {
        title: '视频课程管理',
        icon: '',
      },
    },
    {
      path: 'partner_upload',
      name: 'partner_upload_index',
      component: () => import('@/views/management/partnerBackground/videoCourseManagement/components/partnerUpload/index'),
      hidden: true,
      meta: {
        title: '视频上传',
        icon: '',
      },
    },
  ],
}

export const PartnerManagementRouters = {
  path: '/partner_management',
  component: Layout,
  meta: {
    title: '合作商管理',
    icon: 'account-box-fill',
    alwaysShow: true,
  },
  redirect: '/partner_management/index',
  children: [
    {
      path: 'index',
      name: 'management_video_course',
      component: () => import('@/views/management/partnerManagement/videoCourseManagement/index'),
      meta: {
        title: '视频课程管理',
        icon: '',
      },
    },
    {
      path: 'batch_upload',
      name: 'batch_upload_index',
      component: () => import('@/views/management/partnerManagement/batchUpload/index'),
      // hidden: true,
      meta: {
        title: '批量上传视频',
        icon: '',
      },
    },
  ],
}

export const ManageExamtimeRouter = {
  path: '/manage_examtime',
  component: Layout,
  meta: {
    title: '考试时间分组管理',
    icon: '',
  },
  hidden: true,
  redirect: '/manage_examtime/index',
  children: [
    {
      path: 'index',
      name: 'manage_examtime_index',
      component: () => import('@/views/management/manageExamtime/index'),
      meta: {
        title: '考试分组管理',
        icon: 'time-line',
      },
    },
  ],
}
